import { render, staticRenderFns } from "./AkbsRegisteredList.vue?vue&type=template&id=40f3d15c&scoped=true&"
import script from "./AkbsRegisteredList.vue?vue&type=script&lang=js&"
export * from "./AkbsRegisteredList.vue?vue&type=script&lang=js&"
import style0 from "./AkbsRegisteredList.vue?vue&type=style&index=0&id=40f3d15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3d15c",
  null
  
)

export default component.exports